import { render, staticRenderFns } from "./PlanesInformes.vue?vue&type=template&id=30bc963c&"
import script from "./PlanesInformes.vue?vue&type=script&lang=js&"
export * from "./PlanesInformes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports